import { FunctionComponent } from 'react';
import { CompPropsWithChildren, ContainerProps } from './utils/types';

import { useSortableContainer } from './useSortableContainer';

export const SortableComponentContainer = <Props extends Record<string, any>>(
  Component: FunctionComponent<Props>
) => {
  const WrappedComponent = (
    props: CompPropsWithChildren<
      FunctionComponent<
        Omit<Props, 'reactSortableRef' | 'reactSortableMouseDownHandler'> &
          ContainerProps
      >
    >
  ) => {
    const { compProps, mouseDownHandler, ref } = useSortableContainer(props);
    return (
      <Component
        reactSortableRef={ref}
        reactSortableMouseDownHandler={mouseDownHandler}
        {...(compProps as Props)}
      />
    );
  };
  return WrappedComponent;
};
